import {
  HeadlineBig,
  HeadlineMedium,
  HeadlineSmall,
} from "./styles"

import Root from './Root'
import Cover from './Cover'
import Info from './Info'
import Carousel from './Carousel'
import Body from './Body'
import Author from './Author'
import Divider from './Divider'

const Anteroom = {
  Root,
  Cover,
  Info,
  Carousel,
  Body,
  Author,
  Divider,
  HeadlineBig,
  HeadlineMedium,
  HeadlineSmall,
}

export default Anteroom